import { Outlet } from "react-router-dom";
import Superheader from '../components/KalHome/Superheader';
import Endfooter from '../components/Homecomponents/Endfooter';
import Header from "../components/KalHome/Header";
import Footer from "../components/Homecomponents/Footer";
import { useEffect, useState } from "react";
import SocialLinks from "../components/Homecomponents/Sociallinks";

const HeadFootLay = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Outlet />
      <Footer />
      <SocialLinks />
      <Endfooter />
    </>
  )
}

export default HeadFootLay